export enum HeapEventName {
    afterOrderPlacementQuestionsShown = 'Checkout After Order Placement Questions Shown',
    afterOrderPlacementQuestionsSubmission = 'Checkout After Order Placement Questions Submission',
    applePayButtonView = 'ApplePay Button - View',
    beforeOrderPlacementQuestionsShown = 'Checkout Before Order Placement Questions Shown',
    beforeOrderPlacementQuestionsSubmission = 'Checkout Before Order Placement Questions Submission',
    createOrderError = 'OnCreateOrderError',
    createOrderSuccess = 'Create Order Success',
    googlePayButtonView = 'GooglePay Button - View',
    modalCloseButtonClick = 'Checkout Leave Button - Click',
    orderFailure = 'OrderFailure',
    paypalButtonClick = 'Paypal Button - Click',
    paypalButtonView = 'Paypal Button - View',
    placeOrderSuccess = 'Place Order Success',
    previousPageClick = 'Checkout Back Button - Click',
    routerLocationChange = 'Checkout Router Location Change',
    submit = 'Checkout Submit',
    ticketSelectionPromoCodeError = 'PromoError',
    timerExpired = 'TimerExpired',
    onlineTimedEntryEventCurrentTimezone = 'TimedEntry - Online Event Current Timezone',
    timedEntryMonthSelectorClick = 'TimedEntry - MonthSelector - Click',
    timedEntryDateSelectorClick = 'TimedEntry - DateSelector - Click',
    timedEntryDateAccordionSectionClick = 'TimedEntry - DateAccordion - Click',
    timedEntryDateAccordionScroll = 'TimedEntry - DateAccordion - Scroll',
    timedEntrySessionSelectorClick = 'TimedEntry - SessionSelector - Click',
    timedEntrySessionAccordionSectionClick = 'TimedEntry - SessionAccordion - Click',
    timedEntryCalendarExperience = 'TimedEntry - Calendar Experience',
    paymentMethodSelected = 'Checkout - Click - Payment Method Selected',
    stripeElementView = 'Checkout - Form - View - Stripe Element',
    stripeElementReady = 'Checkout - Form - Ready - Stripe Element',
    stripeElementError = 'Checkout - Form - Error - Stripe Element',
    checkoutFormWithEmptyOrder = 'Checkout - Form - Error - Empty Order',
    externalPaymentPageNotOpened = 'Checkout - External Payment Page Not Opened',
}
